// icons as inline svg to display them in Safari without blur bugs
import classes from './DifferenceSolution.module.scss'

export const IconAI = () => {
  return (
    <svg
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classes.icon}
    >
      <g filter='url(#filter0_b_827_2376)'>
        <g clipPath='url(#clip0_827_2376)'>
          <g filter='url(#filter1_d_827_2376)'>
            <path
              d='M20.194 25.9992L19.2918 23.1577H14.7486L13.8463 25.9992H11L15.3984 14H18.6313L23.0457 25.9992H20.194ZM18.658 21.0317L17.7559 18.252C17.6968 18.0667 17.6217 17.8299 17.5304 17.5365C17.4391 17.2431 17.3424 16.9496 17.2511 16.6458C17.1598 16.3421 17.0793 16.0797 17.0256 15.8584C16.9665 16.0797 16.8912 16.3576 16.7892 16.6871C16.6872 17.0165 16.5958 17.3306 16.5045 17.624C16.4133 17.9174 16.3489 18.1284 16.3059 18.252L15.4091 21.0317H18.658Z'
              fill='url(#paint0_linear_827_2376)'
            />
            <path
              d='M26.3579 26V14.0523H29V26H26.3579Z'
              fill='url(#paint1_linear_827_2376)'
            />
          </g>
          <circle cx='13.5' cy='10.5' r='0.5' fill='white' />
          <circle cx='23.5' cy='30.5' r='0.5' fill='white' />
          <circle cx='5.5' cy='16.5' r='0.5' fill='white' />
          <circle cx='7.5' cy='18.5' r='0.5' fill='white' />
          <circle cx='13.5' cy='30.5' r='0.5' fill='white' />
          <circle cx='31.5' cy='9.5' r='0.5' fill='white' />
          <circle cx='27.5' cy='7.5' r='0.5' fill='white' />
          <circle cx='27.5' cy='31.5' r='0.5' fill='white' />
        </g>
        <rect
          x='0.5'
          y='0.5'
          width='39'
          height='39'
          rx='9.5'
          stroke='url(#paint2_linear_827_2376)'
          strokeOpacity='0.5'
        />
      </g>
      <defs>
        <filter
          id='filter0_b_827_2376'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='20' />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_827_2376'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_backgroundBlur_827_2376'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_d_827_2376'
          x='-2.6'
          y='0.4'
          width='45.2'
          height='39.2'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='6.8' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.61 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_827_2376'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_827_2376'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_827_2376'
          x1='20'
          y1='14'
          x2='20'
          y2='26'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_827_2376'
          x1='20'
          y1='14'
          x2='20'
          y2='26'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_827_2376'
          x1='0'
          y1='20'
          x2='40'
          y2='20'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1A1F39' />
          <stop offset='1' stopColor='#1A1F39' stopOpacity='0.8' />
        </linearGradient>
        <clipPath id='clip0_827_2376'>
          <rect width='40' height='40' rx='10' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconUseCase = () => {
  return (
    <svg
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classes.icon}
    >
      <g filter='url(#filter0_b_827_2389)'>
        <g clipPath='url(#clip0_827_2389)'>
          <path
            d='M9 26.1188C9 26.8771 10.8443 27.4918 13.1188 27.4918C15.3933 27.4918 17.2376 26.8771 17.2376 26.1188M9 26.1188C9 26.6597 9.10654 27.1953 9.31353 27.695C9.52052 28.1947 9.82391 28.6488 10.2064 29.0313C10.5888 29.4137 11.0429 29.7171 11.5426 29.9241C12.0423 30.1311 12.5779 30.2376 13.1188 30.2376C13.6597 30.2376 14.1953 30.1311 14.695 29.9241C15.1947 29.7171 15.6488 29.4137 16.0313 29.0313C16.4137 28.6488 16.7171 28.1947 16.9241 27.695C17.1311 27.1953 17.2376 26.6597 17.2376 26.1188M9 26.1188C9 25.5779 9.10654 25.0423 9.31353 24.5426C9.52052 24.0429 9.82391 23.5888 10.2064 23.2064C10.5888 22.8239 11.0429 22.5205 11.5426 22.3135C12.0423 22.1065 12.5779 22 13.1188 22C13.6597 22 14.1953 22.1065 14.695 22.3135C15.1947 22.5205 15.6488 22.8239 16.0313 23.2064C16.4137 23.5888 16.7171 24.0429 16.9241 24.5426C17.1311 25.0423 17.2376 25.5779 17.2376 26.1188'
            stroke='url(#paint0_linear_827_2389)'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <g filter='url(#filter1_d_827_2389)'>
            <path
              d='M23.9523 29.7825C23.9789 29.902 24.0414 30.0105 24.1314 30.0935C24.2214 30.1764 24.3346 30.2298 24.4559 30.2466C24.5771 30.2634 24.7006 30.2426 24.8097 30.1872C24.9189 30.1318 25.0085 30.0444 25.0665 29.9366L26.1116 28.3898L28.5655 30.8437C28.6151 30.8933 28.6739 30.9326 28.7386 30.9594C28.8034 30.9862 28.8727 31 28.9428 31C29.0129 31 29.0823 30.9862 29.147 30.9594C29.2118 30.9326 29.2706 30.8933 29.3201 30.8437L29.8437 30.3201C29.8933 30.2706 29.9326 30.2118 29.9594 30.147C29.9862 30.0823 30 30.0129 30 29.9428C30 29.8727 29.9862 29.8034 29.9594 29.7386C29.9326 29.6739 29.8933 29.6151 29.8437 29.5655L27.3898 27.1116L28.9466 26.0665C29.0544 26.0084 29.1418 25.9188 29.1972 25.8096C29.2526 25.7005 29.2732 25.577 29.2564 25.4557C29.2396 25.3344 29.1861 25.2212 29.1031 25.1312C29.0201 25.0413 28.9116 24.9788 28.792 24.9523L22.8686 23.2497C22.4908 23.1411 22.1413 23.4908 22.25 23.8685L23.9523 29.7825Z'
              fill='url(#paint1_linear_827_2389)'
            />
          </g>
          <path
            d='M26.0578 8.34082C26.1494 8.34082 26.2396 8.36262 26.32 8.40423C26.4004 8.44583 26.4685 8.50591 26.518 8.57894L30.8266 15.3183C30.9617 15.5171 31.0208 15.7537 30.9941 15.9887C30.9674 16.2238 30.8566 16.443 30.68 16.6101L29.2923 17.9227C29.0869 18.1167 28.809 18.226 28.5191 18.226H23.5965C23.3066 18.226 23.0287 18.1167 22.8233 17.9227L21.4356 16.6101C21.259 16.443 21.1482 16.2238 21.1215 15.9887C21.0948 15.7537 21.1539 15.5171 21.289 15.3183L25.5976 8.57894C25.6471 8.50591 25.7152 8.44583 25.7956 8.40423C25.876 8.36262 25.9662 8.34082 26.0578 8.34082ZM26.0578 8.34082L23.3121 18.1739M26.0578 8.34082L28.8036 18.1739'
            stroke='url(#paint2_linear_827_2389)'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13.4264 18.226C13.2923 18.226 13.1601 18.1901 13.0402 18.1212L9.5463 16.1175C9.49157 16.0859 9.4433 16.0415 9.40467 15.987C9.36604 15.9325 9.33793 15.8693 9.32218 15.8015C9.30644 15.7337 9.30342 15.6629 9.31332 15.5936C9.32322 15.5244 9.34582 15.4584 9.37964 15.3998L13.067 8.56127C13.1063 8.49348 13.1597 8.43787 13.2224 8.39941C13.2851 8.36095 13.3551 8.34082 13.4262 8.34082M13.4264 18.226C13.5605 18.226 13.6928 18.1901 13.8126 18.1212L17.3065 16.1175C17.5388 15.9841 17.6165 15.6475 17.4728 15.3998L13.7854 8.56127C13.7461 8.49348 13.6927 8.43787 13.63 8.39941C13.5673 8.36095 13.4973 8.34082 13.4262 8.34082M13.4264 18.226L13.4262 8.34082'
            stroke='url(#paint3_linear_827_2389)'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <rect
          x='0.5'
          y='0.5'
          width='39'
          height='39'
          rx='9.5'
          stroke='url(#paint4_linear_827_2389)'
          strokeOpacity='0.5'
        />
      </g>
      <defs>
        <filter
          id='filter0_b_827_2389'
          x='-40'
          y='-40'
          width='120'
          height='120'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='20' />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_827_2389'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_backgroundBlur_827_2389'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_d_827_2389'
          x='8.62949'
          y='9.62949'
          width='34.9705'
          height='34.9705'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='6.8' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.61 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_827_2389'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_827_2389'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_827_2389'
          x1='13.1188'
          y1='22'
          x2='13.1188'
          y2='30.2376'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_827_2389'
          x1='26'
          y1='23'
          x2='26'
          y2='31'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_827_2389'
          x1='26.0578'
          y1='8.34082'
          x2='26.0578'
          y2='18.226'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_827_2389'
          x1='13.4264'
          y1='8.34082'
          x2='13.4264'
          y2='18.226'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_827_2389'
          x1='0'
          y1='20'
          x2='40'
          y2='20'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1A1F39' />
          <stop offset='1' stopColor='#1A1F39' stopOpacity='0.8' />
        </linearGradient>
        <clipPath id='clip0_827_2389'>
          <rect width='40' height='40' rx='10' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconStructure = () => {
  return (
    <svg
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classes.icon}
    >
      <g filter='url(#filter0_b_827_2400)'>
        <g clipPath='url(#clip0_827_2400)'>
          <path
            opacity='0.1'
            d='M7.43782 9.78868L13 6.57735L18.5622 9.78868V16.2113L13 19.4226L7.43782 16.2113V9.78868Z'
            stroke='url(#paint0_linear_827_2400)'
          />
          <path
            opacity='0.1'
            d='M10.5 26L13 28.5L10.5 31L8 28.5L10.5 26Z'
            fill='url(#paint1_linear_827_2400)'
          />
          <g filter='url(#filter1_d_827_2400)'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M21.8611 11.4633C21.3878 9.51222 18.6122 9.51222 18.1389 11.4633C17.8322 12.7244 16.3922 13.3222 15.2811 12.6467C13.5656 11.6022 11.6033 13.5656 12.6478 15.28C12.8048 15.5375 12.8988 15.8284 12.9221 16.1291C12.9454 16.4298 12.8974 16.7318 12.7819 17.0104C12.6665 17.289 12.4869 17.5364 12.2578 17.7325C12.0286 17.9286 11.7564 18.0679 11.4633 18.1389C9.51222 18.6122 9.51222 21.3878 11.4633 21.8611C11.7562 21.9323 12.0281 22.0716 12.257 22.2677C12.4858 22.4638 12.6652 22.7111 12.7805 22.9896C12.8958 23.268 12.9438 23.5698 12.9205 23.8703C12.8973 24.1707 12.8034 24.4615 12.6467 24.7189C11.6022 26.4344 13.5656 28.3967 15.28 27.3522C15.5375 27.1952 15.8284 27.1012 16.1291 27.0779C16.4298 27.0546 16.7318 27.1026 17.0104 27.2181C17.289 27.3335 17.5364 27.5131 17.7325 27.7422C17.9286 27.9714 18.0679 28.2436 18.1389 28.5367C18.6122 30.4878 21.3878 30.4878 21.8611 28.5367C21.9323 28.2438 22.0716 27.9719 22.2677 27.743C22.4638 27.5142 22.7111 27.3348 22.9896 27.2195C23.268 27.1042 23.5698 27.0562 23.8703 27.0795C24.1707 27.1027 24.4615 27.1966 24.7189 27.3533C26.4344 28.3978 28.3967 26.4344 27.3522 24.72C27.1952 24.4625 27.1012 24.1716 27.0779 23.8709C27.0546 23.5702 27.1026 23.2682 27.2181 22.9896C27.3335 22.711 27.5131 22.4636 27.7422 22.2675C27.9714 22.0714 28.2436 21.9321 28.5367 21.8611C30.4878 21.3878 30.4878 18.6122 28.5367 18.1389C28.2438 18.0677 27.9719 17.9284 27.743 17.7323C27.5142 17.5362 27.3348 17.2889 27.2195 17.0104C27.1042 16.732 27.0562 16.4302 27.0795 16.1297C27.1027 15.8293 27.1966 15.5385 27.3533 15.2811C28.3978 13.5656 26.4344 11.6033 24.72 12.6478C24.4625 12.8048 24.1716 12.8988 23.8709 12.9221C23.5702 12.9454 23.2682 12.8974 22.9896 12.7819C22.711 12.6665 22.4636 12.4869 22.2675 12.2578C22.0714 12.0286 21.9321 11.7564 21.8611 11.4633ZM17.643 22.357C17.0179 21.7319 16.6667 20.8841 16.6667 20C16.6667 19.1159 17.0179 18.2681 17.643 17.643C18.2681 17.0179 19.1159 16.6667 20 16.6667C20.8841 16.6667 21.7319 17.0179 22.357 17.643C22.9821 18.2681 23.3333 19.1159 23.3333 20C23.3333 20.8841 22.9821 21.7319 22.357 22.357C21.7319 22.9821 20.8841 23.3333 20 23.3333C19.1159 23.3333 18.2681 22.9821 17.643 22.357Z'
              fill='url(#paint2_linear_827_2400)'
            />
          </g>
          <path
            opacity='0.1'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M28.3674 21.591C27.5555 20.803 26.2644 20.803 25.4526 21.591L24.5787 22.4393C24.3302 22.6804 24.0259 22.8561 23.6929 22.9507L22.5213 23.2834C21.433 23.5924 20.7874 24.7106 21.0639 25.8076L21.3616 26.9886C21.4462 27.3243 21.4462 27.6757 21.3616 28.0114L21.0639 29.1924C20.7874 30.2894 21.433 31.4076 22.5213 31.7166L23.6929 32.0493C24.0259 32.1439 24.3302 32.3196 24.5787 32.5608L25.4526 33.409C26.2644 34.197 27.5555 34.197 28.3674 33.409L29.2413 32.5608C29.4897 32.3196 29.794 32.1439 30.127 32.0493L31.2986 31.7166C32.3869 31.4076 33.0325 30.2894 32.756 29.1924L32.4583 28.0114C32.3737 27.6757 32.3737 27.3243 32.4583 26.9886L32.756 25.8076C33.0325 24.7106 32.3869 23.5924 31.2986 23.2834L30.127 22.9507C29.794 22.8561 29.4897 22.6804 29.2413 22.4393L28.3674 21.591ZM26.9099 31.6849C29.2211 31.6849 31.0948 29.8113 31.0948 27.5C31.0948 25.1887 29.2211 23.3151 26.9099 23.3151C24.5986 23.3151 22.7249 25.1887 22.7249 27.5C22.7249 29.8113 24.5986 31.6849 26.9099 31.6849Z'
            fill='url(#paint3_linear_827_2400)'
          />
        </g>
        <path
          d='M0.5 10C0.5 4.7533 4.7533 0.5 10 0.5H30C35.2467 0.5 39.5 4.7533 39.5 10V30C39.5 35.2467 35.2467 39.5 30 39.5H10C4.7533 39.5 0.5 35.2467 0.5 30V10Z'
          stroke='url(#paint4_linear_827_2400)'
          strokeOpacity='0.5'
        />
      </g>
      <defs>
        <filter
          id='filter0_b_827_2400'
          x='-40'
          y='-40'
          width='120'
          height='120'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='20' />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_827_2400'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_backgroundBlur_827_2400'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_d_827_2400'
          x='-3.6'
          y='-3.6'
          width='47.2'
          height='47.2'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='6.8' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.61 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_827_2400'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_827_2400'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_827_2400'
          x1='13'
          y1='6'
          x2='13'
          y2='20'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_827_2400'
          x1='10.5'
          y1='26'
          x2='10.5'
          y2='31'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_827_2400'
          x1='20'
          y1='10'
          x2='20'
          y2='30'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_827_2400'
          x1='26.91'
          y1='21'
          x2='26.91'
          y2='34'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_827_2400'
          x1='0'
          y1='20'
          x2='40'
          y2='20'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1A1F39' />
          <stop offset='1' stopColor='#1A1F39' stopOpacity='0.8' />
        </linearGradient>
        <clipPath id='clip0_827_2400'>
          <path
            d='M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconPrice = () => {
  return (
    <svg
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classes.icon}
    >
      <g filter='url(#filter0_b_827_2410)'>
        <g clipPath='url(#clip0_827_2410)'>
          <path
            d='M16.6155 20.0577H13.9713C13.5505 20.0577 13.147 20.2248 12.8495 20.5224C12.5519 20.8199 12.3848 21.2235 12.3848 21.6442C12.3848 22.065 12.5519 22.4685 12.8495 22.7661C13.147 23.0636 13.5505 23.2308 13.9713 23.2308H15.029C15.4498 23.2308 15.8533 23.3979 16.1508 23.6955C16.4484 23.993 16.6155 24.3965 16.6155 24.8173C16.6155 25.2381 16.4484 25.6416 16.1508 25.9392C15.8533 26.2367 15.4498 26.4038 15.029 26.4038H12.3848M14.5001 26.4038V27.4615M14.5001 19V20.0577'
            stroke='url(#paint0_linear_827_2410)'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9 16.5009L14.5 14L20 16.5009L20 31.2308H9L9 16.5009Z'
            stroke='url(#paint1_linear_827_2410)'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M14.5003 15.9996L13.8448 15.3441C12.1994 13.6987 12.6495 10.9249 14.7308 9.88433C15.825 9.33722 17.1284 9.41837 18.1464 10.097L24.0003 13.9996L24.9923 14.5783C26.5029 15.4594 28.2724 15.2259 29.5002 14.2535'
            stroke='url(#paint2_linear_827_2410)'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <g filter='url(#filter1_d_827_2410)'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M29 13.25C28.6287 13.25 28.2726 13.4036 28.0101 13.6771C27.7475 13.9506 27.6 14.3216 27.6 14.7083V16.7917C27.6 17.1368 27.3314 17.4167 27 17.4167C26.6686 17.4167 26.4 17.1368 26.4 16.7917V14.7083C26.4 13.99 26.6739 13.3012 27.1615 12.7933C27.6491 12.2853 28.3104 12 29 12C29.6896 12 30.3509 12.2853 30.8385 12.7933C31.3261 13.3012 31.6 13.99 31.6 14.7083V16.7917C31.6 17.1368 31.3314 17.4167 31 17.4167C30.6686 17.4167 30.4 17.1368 30.4 16.7917V14.7083C30.4 14.3216 30.2525 13.9506 29.9899 13.6771C29.7274 13.4036 29.3713 13.25 29 13.25Z'
              fill='url(#paint3_linear_827_2410)'
            />
            <path
              d='M25 17.8333C25 17.5571 25.1054 17.2921 25.2929 17.0968C25.4804 16.9014 25.7348 16.7917 26 16.7917H32C32.2652 16.7917 32.5196 16.9014 32.7071 17.0968C32.8946 17.2921 33 17.5571 33 17.8333V20.9583C33 21.2346 32.8946 21.4996 32.7071 21.6949C32.5196 21.8903 32.2652 22 32 22H26C25.7348 22 25.4804 21.8903 25.2929 21.6949C25.1054 21.4996 25 21.2346 25 20.9583V17.8333Z'
              fill='url(#paint4_linear_827_2410)'
            />
          </g>
        </g>
        <path
          d='M0.5 10C0.5 4.7533 4.7533 0.5 10 0.5H30C35.2467 0.5 39.5 4.7533 39.5 10V30C39.5 35.2467 35.2467 39.5 30 39.5H10C4.7533 39.5 0.5 35.2467 0.5 30V10Z'
          stroke='url(#paint5_linear_827_2410)'
          strokeOpacity='0.5'
        />
      </g>
      <defs>
        <filter
          id='filter0_b_827_2410'
          x='-40'
          y='-40'
          width='120'
          height='120'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='20' />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_827_2410'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_backgroundBlur_827_2410'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_d_827_2410'
          x='11.4'
          y='-1.6'
          width='35.2'
          height='37.2'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='6.8' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.61 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_827_2410'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_827_2410'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_827_2410'
          x1='14.5001'
          y1='19'
          x2='14.5001'
          y2='27.4615'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_827_2410'
          x1='14.5'
          y1='14'
          x2='14.5'
          y2='31.2308'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_827_2410'
          x1='21.7502'
          y1='6.7387'
          x2='21.7502'
          y2='17.6952'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_827_2410'
          x1='29'
          y1='12'
          x2='29'
          y2='22'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_827_2410'
          x1='29'
          y1='12'
          x2='29'
          y2='22'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#BBC0C7' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_827_2410'
          x1='0'
          y1='20'
          x2='40'
          y2='20'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1A1F39' />
          <stop offset='1' stopColor='#1A1F39' stopOpacity='0.8' />
        </linearGradient>
        <clipPath id='clip0_827_2410'>
          <path
            d='M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
